import { Component, OnDestroy, OnInit } from '@angular/core';
import { WebkassaOrgAuthModel } from 'hx-services';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { WebkassaCashboxService } from '@adm-web-app/services/webkassa-cashbox.service';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { HxOrgSelectComponent } from 'hx-components';
import { NzRadioComponent, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NgIf } from '@angular/common';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTagComponent } from 'ng-zorro-antd/tag';

@Component({
    selector: 'hc-webkassa-org-auth-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzSkeletonComponent, TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, HxOrgSelectComponent, NzRadioGroupComponent, NzRadioComponent, NzInputDirective, NzDatePickerComponent, NgIf, NzAlertComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, NzTagComponent, TranslocoPipe]
})
export class WebkassaOrgAuthEditComponent implements OnInit, OnDestroy {
  model?: WebkassaOrgAuthModel;
  isEdit = false;
  isCreate = false;
  form = new FormGroup({
    enabled: new FormControl<boolean | null>(null, [Validators.required]),
    organizationId: new FormControl<number | null>(null, [Validators.required]),
    login: new FormControl<string | null>(null, [Validators.required]),
    password: new FormControl<string | null>(null, [Validators.required]),
    token: new FormControl<string | null>(null),
    tokenDate: new FormControl<string | null>(null),
  });

  isSaving = false;
  isLoading = {
    model: false,
  };
  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private webkassaCashboxService: WebkassaCashboxService,
    private tr: TranslocoService,
    private notification: NzNotificationService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['model'] as WebkassaOrgAuthModel;
    if (this.model) {
      this.isEdit = true;
    } else {
      this.isCreate = true;
    }
    this.form.patchValue({
      enabled: this.model.enabled,
      organizationId: this.model.organizationId,
      login: this.model.login,
      password: this.model.password,
      token: this.model.token,
      tokenDate: this.model.tokenDate,
    });
  }

  async submitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      try {
        const formModel = this.form.value;
        if (formModel.enabled === null || formModel.enabled === undefined
          || !formModel.organizationId
          || !formModel.login
          || !formModel.password
        ) {
          throw new Error('form.required.fields');
        }

        this.isSaving = true;
        const {id} = await this.webkassaCashboxService.saveOrgAuth({
          id: this.model?.id,
          enabled: formModel.enabled,
          organizationId: formModel.organizationId,
          login: formModel.login,
          password: formModel.password,
          token: formModel.token ?? undefined,
          tokenDate: formModel.tokenDate ?? undefined,
        });
        this.form.markAsPristine();
        this.notification.create('success', 'Webkassa', this.tr.translate('nt.dataSaved'));

        if (this.isCreate) {
          await this.router.navigate([`/webkassa-cashboxes/org-auths/${id}/edit`]);
        } else {
          this.isLoading.model = true;
          this.model = await this.webkassaCashboxService.getOrgAuthById(id);
        }
      } finally {
        this.isSaving = false;
        this.isLoading.model = false;
      }
    } else {
      console.log('not valid form');
    }
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }
}
